import { render, staticRenderFns } from "./AuctionProgramPage.vue?vue&type=template&id=4ede2b18&"
import script from "./AuctionProgramPage.vue?vue&type=script&lang=js&"
export * from "./AuctionProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports